
<div  class="d-flex justify-content-center align-items-center p-0 m-0 position-relative content-wrapper">
    <div class="content position-relative">
        <button mat-dialog-close mat-mini-fab color="warn" class="position-absolute mat-dialog-close">
            <mat-icon> close</mat-icon>
        </button>
        <ng-container [ngSwitch]="contentType">
            <ng-container *ngSwitchCase="contentTypes.IMAGE">
                <ng-container *ngIf="isMultimediaType;else fileTypeImage" >
                    <img [src]="contentSource" alt="file content">
                </ng-container>
                 <ng-template #fileTypeImage>
                    <img [ngfSrc]="contentSource" [alt]="'file content'">
                 </ng-template>
            </ng-container>
            <ng-container *ngSwitchCase="contentTypes.VIDEO">
                <ng-container *ngIf="isMultimediaType;else fileTypeVideo" >
                    <video [src]="contentSource" controls></video>
                </ng-container>
                 <ng-template #fileTypeVideo>
                    <video [ngfSrc]="contentSource" controls></video>
                 </ng-template>
               
            </ng-container>
            <ng-container *ngSwitchCase="contentTypes.PDF">
                <div [ngClass]="showProgressIdicator ? 'd-flex justify-content-center align-items-center show-progress-indicator': 'd-none'">
                    <mat-spinner color="primary"></mat-spinner>
                </div>
                <iframe [ngClass]="showProgressIdicator ? 'invisible': 'visible'" (load)="toggleLoading()" style="overflow:scroll;" frameborder="0" [src]="contentSource" scrolling="yes"></iframe>
            </ng-container>
            <div *ngSwitchDefault>{{contentTypes.NOT_SUPPORTED}}</div>
        </ng-container>
    </div>
</div>

